import { ENV } from "../utils";

export class PlanAnual {
  baseApi = ENV.BASE_API;

  async getPlanesAnuales(accessToken, site) {
    try {
      const url = `${this.baseApi}/planes-anuales/${site}`;
      const params = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async setPlanAnualEstado(accessToken, site, year, estado) {
    try {
      const url = `${this.baseApi}/planes-anuales/${site}/${year}`;
      const params = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ estado }),
      };
      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 200) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }
}
